"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583",
    cx: "7.9813662",
    cy: "11.668264",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583-5",
    cx: "16.091457",
    cy: "11.69252",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 6.1397441,5.7893981 3.532238,2.0393385",
    id: "path3615"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    d: "M 2.5840862,6.4995534 9.6028763,10.691121",
    id: "path3615-3-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 2.3495516,9.013272 6.6032392,3.799611",
    id: "path3615-3-5-4-2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 1.9138374,11.447198 8.6694016,4.988515",
    id: "path3615-3-5-4-2-0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 2.1958543,13.873604 7.0187905,4.191568",
    id: "path3615-3-5-6"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g928",
    transform: "translate(1.0545248,-9.9233485)",
    strokeWidth: "1",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: ["\"", /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path3615-5",
      d: "m 13.329636,25.50686 3.532238,2.039339",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: "1",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    }), "\"", /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path3615-3-5-4",
      d: "m 13.180905,22.674894 7.01879,4.191567",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    }), "\"", /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path3615-3-5-4-2-4",
      d: "m 14.054973,20.564927 6.603239,3.799611",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    }), "\"", /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path3615-3-5-4-2-0-1",
      d: "m 12.835125,17.320643 8.669402,4.988514",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    }), "\"", /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path3615-3-5-6-8",
      d: "m 13.901276,15.52895 7.01879,4.191568",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "1",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      strokeOpacity: "1"
    }), "\""]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 10.807061,8.3521794 3.532238,2.0393386",
    id: "path3615-0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    d: "m 10.04692,10.516477 3.76235,2.172195",
    id: "path3615-0-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 9.9889885,13.179827 3.7623495,2.172195",
    id: "path3615-0-5-7"
  })]
}));